module.exports = "/_next/static/images/logo-light-ru-a6578ea4fc744dc5d095fdf272c5a498.png";